import reduce from 'lodash-es/reduce';
import map from 'lodash-es/map';
import isString from 'lodash-es/isString';
import kebabCase from 'lodash-es/kebabCase';

function js2css(CSS, id) {
  return reduce(
    CSS || [],
    function(res, rule) {
      if (!rule.properties && rule.rule) {
        rule.properties = rule.rule;
      }

      if (rule.selector && rule.properties) {
        var selector = map(rule.selector.split(','), function(s) {
          return (id + ' ' + s).replace(' &', '');
        }).join(',');

        var props = isString(rule.properties)
          ? rule.properties
          : map(rule.properties, function(v, p) {
              return kebabCase(p) + ': ' + v + ';';
            }).join('\n  ');
        return res + '\n' + selector + ' {\n  ' + props + '\n}';
      } else {
        return res;
      }
    },
    ''
  );
}

function updateClass(styleEl, CSS, id) {
  if (isString(styleEl)) {
    let elId = styleEl;
    styleEl = document.getElementById(elId);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.setAttribute('id', elId);
    }
  }

  styleEl.innerHTML = js2css(CSS, id);

  if (!document.body.contains(styleEl)) {
    document.body.appendChild(styleEl);
  }

  return styleEl;
}

export { js2css, updateClass as default };
